import { HTTP_METHODS } from '@studio/constants/axios';
import { MEDIA_METADATA_API_V1 } from '@studio/constants/env-variables';
import type { Clips } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/media/@mediaId/clips`,
    response: [] as Clips.Get.Clip[],
    params: {} as { mediaId: string },
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
